import { render, staticRenderFns } from "./indexLy.vue?vue&type=template&id=6dce1d66&scoped=true"
import script from "./indexLy.vue?vue&type=script&lang=js"
export * from "./indexLy.vue?vue&type=script&lang=js"
import style0 from "./indexLy.vue?vue&type=style&index=0&id=6dce1d66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dce1d66",
  null
  
)

export default component.exports